// src/lib/managers/music/types/const.ts

export const MUSIC_CDN_URL =
    "https://teamwaycdn.blob.core.windows.net/mailvista/";
